<template>
  <div id="empty-main">
    <div>
      <img src="@/assets/empty.png" class="image-tip">
      <p class="empty-title">
        {{emptyData}}
      </p>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmptyData',
  props: {
    emptyData: {
      type: String,
      default: '暂无相关数据',
    },
  },
};
</script>

<style scoped>
#empty-main{
  width:100%;
  min-height: 350px;
  justify-content:center;
  align-items:center;
  display:flex;
  text-align: center
}
.empty-title{
  color: rgba(153,153,153,1);
  font-size: 14px;
  font-weight: 400;
  margin-top:10px;
}
</style>
